import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@/components/ui/card';

/**
 * StatCard - Atomic component for displaying a single statistic
 */
const StatCard = ({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  colorScheme = 'blue' 
}) => {
  const colorClasses = {
    blue: {
      gradient: 'from-blue-50 to-blue-100',
      border: 'border-blue-200',
      title: 'text-blue-600',
      value: 'text-blue-900',
      subtitle: 'text-blue-600',
      iconBg: 'bg-blue-500'
    },
    green: {
      gradient: 'from-green-50 to-green-100',
      border: 'border-green-200',
      title: 'text-green-600',
      value: 'text-green-900',
      subtitle: 'text-green-600',
      iconBg: 'bg-green-500'
    },
    purple: {
      gradient: 'from-purple-50 to-purple-100',
      border: 'border-purple-200',
      title: 'text-purple-600',
      value: 'text-purple-900',
      subtitle: 'text-purple-600',
      iconBg: 'bg-purple-500'
    },
    amber: {
      gradient: 'from-amber-50 to-amber-100',
      border: 'border-amber-200',
      title: 'text-amber-600',
      value: 'text-amber-900',
      subtitle: 'text-amber-600',
      iconBg: 'bg-amber-500'
    }
  };

  const colors = colorClasses[colorScheme] || colorClasses.blue;

  return (
    <Card className={`bg-gradient-to-br ${colors.gradient} ${colors.border}`}>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div>
            <p className={`text-sm font-medium ${colors.title}`}>{title}</p>
            <p className={`text-2xl font-bold ${colors.value}`}>{value}</p>
            {subtitle && (
              <p className={`text-xs ${colors.subtitle} mt-1`}>{subtitle}</p>
            )}
          </div>
          {Icon && (
            <div className={`h-12 w-12 ${colors.iconBg} rounded-full flex items-center justify-center`}>
              <Icon className="h-6 w-6 text-white" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.elementType,
  colorScheme: PropTypes.oneOf(['blue', 'green', 'purple', 'amber'])
};

StatCard.defaultProps = {
  subtitle: null,
  icon: null,
  colorScheme: 'blue'
};

export default StatCard;
